export const PUBLISHING_CHANNEL_MODEL = "publishing-channel";

const publishingChannelModel = {
  channelName: ""
};

export default publishingChannelModel;
